module.exports = __webpack_public_path__ + "img/4.3fd2ed79.jpg";